import { useEffect } from "react";

const usePreventBodyScroll = (prevent: boolean) => {
  useEffect(() => {
    if (prevent) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [prevent]);
};

export default usePreventBodyScroll;
